import { Navigate } from 'react-router-dom'
import AppLayout from '../components/layout/AppLayout'
import MobileLauncherGrid from '../components/layout/mobile/MobileLauncherGrid'
import { useIsMobile } from '../hooks/useIsMobile'
import { useAdminGuard } from '../hooks/useAdminGuard'
import { useCadastroRecebimentoStatus } from '../hooks/useCadastroRecebimentoStatus'

/**
 * Início (launcher v2, mobile-only): grid de todas as seções, agrupado.
 * No desktop a rota redireciona pro Painel — o conceito de "Início" não existe lá.
 */
export default function MobileHomePage() {
  const isMobile = useIsMobile()
  const { isAdmin } = useAdminGuard()
  const { enabled, hasV3 } = useCadastroRecebimentoStatus()

  if (!isMobile) return <Navigate to="/" replace />

  return (
    <AppLayout title="Início">
      <div className="pt-1 pb-4">
        <h1 className="font-display text-xl font-bold text-ink">
          Olá <span aria-hidden>👋</span>
        </h1>
        <p className="text-sm text-ink-muted mb-4">O que vamos fazer hoje?</p>
        <MobileLauncherGrid isAdmin={isAdmin} cadastroRecAvailable={enabled && !hasV3} />
      </div>
    </AppLayout>
  )
}
